import React, { useRef, useState } from 'react';
import ImportQuestion from '../../../component/EliteGame/ImportQuestion';
import { ELITE_QUIZ_TYPE } from '../../../utils/constants';
import { importQuestions } from '../../../api/eliteGameApi';
import { errorToast, successToast } from '../../../utils/helper';
import { useEliteGames } from '../../../context/EliteGamesContext';
const sampleDataByQuizType = {
  GUESS_THE_WORD_SAMPLE_MCQ: {
    headers: [
      { label: 'quiztype', key: 'quiztype' },
      { label: 'category', key: 'category' },
      { label: 'subcategory', key: 'subcategory' },
      { label: 'language', key: 'language' },
      { label: 'question_type', key: 'question_type' },
      { label: 'question', key: 'question' },
      { label: 'answer', key: 'answer' }
    ],
    data: [
      {
        quiztype: '4',
        category: 63,
        subcategory: 97,
        language: 'english',
        question_type: '{3 only for GUESS_THE_WORD}',
        question: 'Sample MCQ Question?',
        answer: 'sample answer'
      },
      {
        quiztype: '4',
        category: 63,
        subcategory: 97,
        language: 'english',
        question_type: '{3 only for GUESS_THE_WORD}',
        question: 'Is the sky blue?',
        answer: 'blue'
      }
    ]
  }
};
const GuessWordImportQues = () => {
  const [examModuleType, setExamModuleType] = useState('GUESS_THE_WORD_SAMPLE_MCQ');
  const [refresh, setRefresh] = useState(false);
  const importRef = useRef(); // ✅ ref to trigger child reset

  const { setLoading } = useEliteGames();
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await importQuestions(data, ELITE_QUIZ_TYPE.GUESS_THE_WORD);
      successToast('Questions imported successfully!', response.message);
      importRef.current?.reset(); // ✅ reset child input after success
    } catch (error) {
      errorToast('No data to submit', error.message);
    } finally {
      setLoading(false);
    }
    setRefresh(!refresh);
  };
  const { headers, data } = sampleDataByQuizType[examModuleType];
  return (
    <div>
      <ImportQuestion
        ref={importRef}
        onSubmit={onSubmit}
        sampleData={data}
        headers={headers}
        filename={`${examModuleType.toLowerCase()}-sample.csv`}
      />
    </div>
  );
};

export default GuessWordImportQues;
